<span class="badge simple-badge" [ngClass]="useExtraClass()" [ngStyle]="useExtraStyles()">
  {{ title }}
</span>
